import apiTCEComunica from '../infra/apiTCEComunica'

const ComunicacaoControleService = {
    ConsultaPorEtapaComunicacao: async (idOrgaoJurisdicionado, etapaComunicacao, pagina, qtdePagina) => {
        if (idOrgaoJurisdicionado === null || idOrgaoJurisdicionado === undefined) { idOrgaoJurisdicionado = 0 }
        return await apiTCEComunica.get(`/api/v1/ControleComunicacao/idOrgaoJurisdicionado/${idOrgaoJurisdicionado}/etapa/${etapaComunicacao}/pagina/${pagina}/qtdePagina/${qtdePagina}`)
    },
    DaAceite: async (controleComunicacao) => {
        return await apiTCEComunica.post(`/api/v1/ControleComunicacao`, controleComunicacao)
    },
    Assina: async (idControle, idOrgaoJurisdicionado) => {
        return await apiTCEComunica.put(`/api/v1/ControleComunicacao/id/${idControle}/idOrgaoJurisdicionado/${idOrgaoJurisdicionado}/ciencia/assina`)
    },
    ConsultaLinkProcessoMaven: async (idOficio) => {
        return await apiTCEComunica.get(`/api/v1/ControleComunicacao/link/processo/maven/idOficio/${idOficio}`)
    },
    DownloadArquivoDocumentoBase64: async (idArquivo, idArquivoDocumento, tipoArquivo) => {
        return await apiTCEComunica.get(`/api/v1/ControleComunicacao/download/base64/arquivo/${idArquivo}/documentocomunicacao/${idArquivoDocumento}/tipo/${tipoArquivo}`)
    },
    DownloadArquivoDocumento8Bits: async (idArquivo, idArquivoDocumento, tipoArquivo) => {
        return await apiTCEComunica.get(`/api/v1/ControleComunicacao/download/8bits/arquivo/${idArquivo}/documentocomunicacao/${idArquivoDocumento}/tipo/${tipoArquivo}`, {
            responseType: 'blob'
        })
    },
    ExportaCsv: async (etapaComunicacao, idOrgaoJurisdicionado) => {
        return await apiTCEComunica({
            method: 'get',
            url: `/api/v1/ControleComunicacao/exporta/csv/etapa/${etapaComunicacao}`,
            headers: {
                'idPessoaOrgaoJurisdicionado': idOrgaoJurisdicionado,
            }
        });
    },
    SalvaReciboResposta: async (idOrgaoJurisdicionado, idControleComunicacao, resposta) => {
        return await apiTCEComunica({
            method: 'post',
            url: `api/v1/ControleComunicacao/reciboresposta/salva/${idOrgaoJurisdicionado}/${idControleComunicacao}`,
            data: resposta
        });
    },
    UploadAnexoReciboResposta: async (arquivo) => {
        return await apiTCEComunica({
            method: 'post',
            url: `/api/v1/ControleComunicacao/upload/anexos/reciboresposta`,
            data: arquivo
        });
    },
}

export default ComunicacaoControleService 